export default __webpack_public_path__ + "static/gc-logo-d9ff1ff41979917e5f0501ddd047b9ce.svg";